import { isLoggedIn, logout, getUserRole, requireAuth } from "./auth.js";

document.addEventListener("DOMContentLoaded", () => {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  const isLoginPage = path === "/login";

  if (!isLoginPage) {
    requireAuth();
  }

  const logoutLink = document.getElementById("logout-link");
  const loginLink = document.querySelector('a[href="/login"]');
  const adminLink = document.querySelector('a[href="/admin"]');
  const homeLink = document.querySelector('a[href="/"]');

  if (isLoggedIn()) {
    logoutLink?.classList.remove("hidden");
    loginLink?.classList.add("hidden");

    if (getUserRole() !== "admin") {
      adminLink?.classList.add("hidden");
    } else {
      adminLink?.classList.remove("hidden");
    }

    homeLink?.classList.remove("hidden");
    logoutLink?.addEventListener("click", (event) => {
      event.preventDefault();
      logout();
    });
  } else {
    logoutLink?.classList.add("hidden");
    adminLink?.classList.add("hidden");
    loginLink?.classList.remove("hidden");
    homeLink?.classList.add("hidden");
  }
});
